import React, { useState } from 'react';
import classNames from 'classnames';
import { interpolateYlGnBu } from 'd3-scale-chromatic';
import { Tooltip } from 'Permafrost/index';
import { StyledMatrix } from './Matrix.styles';
export function Matrix(props) {
    const [selectedPos, setSelectedPos] = useState([-1, -1]);
    const [hovered, setHovered] = useState([-1, -1]);
    const handleCellClick = (row, col) => {
        setSelectedPos([row, col]);
        props.selectionHandler(row, col);
    };
    const onCellHover = (row, col) => {
        setHovered([row, col]);
    };
    const { className, data, id, tooltipPlacement, xAxisLabel, yAxisLabel } = props;
    return (React.createElement(StyledMatrix, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement("table", { className: "Matrix-Frame", onMouseLeave: () => setHovered([-1, -1]) },
            React.createElement("tbody", null,
                React.createElement("tr", { className: "Matrix-Row" },
                    React.createElement("th", { className: "Matrix-Label-Row" }, "\u00A0"),
                    React.createElement("th", { className: "Matrix-Axis-X", colSpan: data.labels.length }, xAxisLabel),
                    React.createElement("td", null)),
                data.matrix.map((row, index) => {
                    const ttKey = `rowLabel${index}`;
                    return (React.createElement("tr", { className: "Matrix-Row", key: ttKey },
                        React.createElement("th", { className: "Matrix-Label-Row" },
                            React.createElement("span", { "data-tip": true, "data-for": ttKey, style: {
                                    color: `${hovered[0] === index ? '#fff' : ''}`,
                                } }, data.labels[index]),
                            React.createElement(Tooltip, { for: ttKey, place: tooltipPlacement },
                                React.createElement("p", null, data.labels[index]))),
                        row.map((cell, rowIndex) => {
                            const cellStyles = {
                                backgroundColor: interpolateYlGnBu(cell),
                            };
                            return (React.createElement("td", { className: classNames('Matrix-Cell', {
                                    selected: index === selectedPos[0] && rowIndex === selectedPos[1],
                                }), style: cellStyles, key: rowIndex, onClick: () => handleCellClick(index, rowIndex), title: cell, onMouseEnter: () => onCellHover(index, rowIndex) },
                                React.createElement("div", { className: "Contents" }, cell)));
                        }),
                        index === 0 && (React.createElement("th", { className: "Matrix-Axis-Y", rowSpan: data.labels.length },
                            React.createElement("span", null, yAxisLabel)))));
                }),
                React.createElement("tr", { className: "Matrix-Row" },
                    React.createElement("th", { className: "Matrix-Label-Row" }, "\u00A0"),
                    data.labels.map((label, index) => {
                        const ttKey = `colLabel${index}`;
                        return (React.createElement("th", { className: "Matrix-Label-Col", key: ttKey },
                            React.createElement("span", { className: "rotate", "data-tip": true, "data-for": ttKey, style: {
                                    color: `${hovered[1] === index ? '#fff' : ''}`,
                                } },
                                React.createElement("span", null, label)),
                            React.createElement(Tooltip, { for: ttKey, place: tooltipPlacement },
                                React.createElement("p", null, label))));
                    }),
                    React.createElement("td", null))))));
}
//# sourceMappingURL=Matrix.js.map